<template>
  <div>
    <base-header class="mt-4 pb-6" type=""/>
        <div>
            <loading :active="loadingCounter > 0" color= '#007bff' :width= '128' :height= '128' loader='dots' :can-cancel="true" is-full-page/>
        </div>
        <b-container fluid class="mt--6">
            <card>
                <div slot="header">
                    <b-row>
                        <b-col lg="6">
                            <h3>{{title}}</h3>
                        </b-col>
                    </b-row>
                </div>
                <b-row>
                    <!-- <b-col :lg="4" v-if="($route.params.id != '_new')">
                        <label class="form-control-label">{{language_terms['CUSTOMER']}}</label>
                        <base-input :lg="4" v-model="form.selected_contact" disabled></base-input>
                    </b-col> -->
                    <b-col :lg="(isEmptyObj(form.selected_contact) ? false : ((form.selected_contact) ? true : false)) ? 4:8">
                        <label class="form-control-label">{{language_terms['VENDOR']}}</label>
                        <multiselect
                            autocomplete="off"
                            class="mt-1"
                            :custom-label="customerNameWithCode"
                            :disabled="!is_editing"
                            v-model="form.selected_contact"
                            placeholder="Type to search"
                            open-direction="bottom"
                            :options="contacts"
                            :multiple="false"
                            :searchable="true"
                            :loading="loading"
                            :clear-on-select="false"
                            :close-on-select="true"
                            :options-limit="300"
                            :limit="50"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="true"
                            @search-change="asyncFindVendor"
                            @select="onSelectCustomer">
                        </multiselect>
                    </b-col>
                    <!-- <b-col :lg="4" v-if="($route.params.id != '_new')">
                        <label class="form-control-label">{{language_terms['INVOICE_NO']}}</label>
                        <base-input :lg="4" v-model="form.selected_invoice" disabled></base-input>
                    </b-col> -->
                    <b-col lg="4" v-if="(isEmptyObj(form.selected_contact) ? false : ((form.selected_contact) ? true : false))">
                       <label class="form-control-label">{{language_terms['INVOICE_NO']}}</label>
                        <multiselect
                                :disabled="!is_editing"
                                class="mt-1"
                                :custom-label="invoiceNameWithCode"
                                v-model="form.selected_invoice"
                                label="name"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :options="invoices"
                                :multiple="false"
                                :searchable="true"
                                :loading="loading"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="300"
                                :limit="50"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="true"
                                @search-change="asyncFindInvoices"
                                @select="onSelectInvoice"
                            >
                        </multiselect>
                    </b-col>
                    <b-col lg="4">
                        <base-input :label="language_terms['DATE']">
                            <flat-picker
                                :disabled="!is_editing"
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                style="background-color: white"
                                class="form-control datepicker"
                                v-model="form.date">
                            </flat-picker>
                        </base-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :lg="form.action_recommended == 'Others' ? 6 : 12">
                      <base-input :label="language_terms['ACTION_RECOMMENDED']">
                        <el-select :disabled="!is_editing" v-model="form.action_recommended" :placeholder="language_terms['ACTION_RECOMMENDED']" >
                            <el-option
                                v-for="item in activeOptions"
                                :key="item.key"
                                :label="item.label"
                                :value="item.label">
                            </el-option>
                        </el-select>
                    </base-input>
                    </b-col>
                    <b-col lg="6">
                        <base-input v-model="form.action_remarks" :label="language_terms['OTHERS']" class="mt-4" v-if="form.action_recommended == 'Others' "></base-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :lg="form.returned == 1 ? 6:12">
                        <base-input :label="language_terms['RETURNED_BY']">
                            <el-select :disabled="!is_editing" v-model="form.returned_by" :placeholder="language_terms['RETURNED_BY']" >
                                <el-option
                                v-for="item in returnedBy"
                                :key="item.key"
                                :label="item.label"
                                :value="item.label"
                                >
                                </el-option>
                            </el-select>
                        </base-input>
                    </b-col>
                    <!-- <b-col lg="6">
                         <base-input v-model="form.returnOthers" :label="language_terms['OTHERS']" class="mt-4" v-if="form.returned == 1" ></base-input>
                    </b-col> -->
                </b-row>
            </card>
            <!-- {{isEmptyObj(selected_invoice)}} -->
            <card v-if="(isEmptyObj(form.selected_invoice) ? false : ((form.selected_invoice) ? true : false)) && (isEmptyObj(form.selected_contact) ? false : ((form.selected_contact) ? true : false))">
                <div slot="header">
                    <b-row>
                        <b-col lg="6">
                            <h3 >{{language_terms['PART_ONE_INFO']}}</h3>
                        </b-col>
                    </b-row>
                </div>
                <!-- zehua -->
                <b-row class="mt--4">
                  <b-col cols="12" class="mt-3">
                    <b-table-simple hover responsive>
                        <b-thead head-variant="light">
                            <b-th>{{language_terms['SNO']}}</b-th>
                            <b-th>{{language_terms['ITEM_CODE']}}</b-th>
                            <b-th>{{language_terms['DESCRIPTION']}}</b-th>
                            <b-th>{{language_terms['INVOICE_QTY']}} </b-th>
                            <b-th>{{language_terms['UOM']}} </b-th>
                            <b-th>{{language_terms['UNIT_PRICE']}} </b-th>
                            <b-th>{{language_terms['QTY']}} </b-th>
                            <b-th>{{language_terms['TOTAL_AMOUNT']}} </b-th>
                        </b-thead>
                        <b-tbody>
                            <tr v-for="(item, i) in form.items" :key="i">
                                <td>{{i + 1}}</td>
                                <td>{{item.product_code}}</td>
                                <td>{{item.product_name}}</td>
                                <td>{{item.qty}}</td>
                                <td>{{item.uom}}</td>
                                <td>{{item.unit_price}}</td>
                                <td>
                                    <base-input v-model="item.qty_return" type="number" :min="0" :max="item.qty" :disabled="!is_editing"> </base-input>
                                </td>
                                <td>
                                    <base-input :value="(item.total_amount = (item.qty_return * item.unit_price)* 1).toLocaleString('en-US', {minimumFractionDigits:4, maximumFractionDigits:4})" disabled></base-input>
                                </td>
                            </tr>
                        </b-tbody>
                    </b-table-simple>
                  </b-col>
                </b-row>
                <hr>
                <b-row class="mt-4">
                    <b-col lg="6">
                        <base-input v-model="form.incident_remarks" :label="language_terms['NONCONFORMANCE']" :disabled="!is_editing"></base-input>
                    </b-col>
                    <b-col lg="6">
                          <base-input v-model="form.instructions" :label="language_terms['INSTRUTIONS']" :disabled="!is_editing"></base-input>
                    </b-col>
                </b-row>
                 <b-row  class="mt-4">
                    <b-col lg="6">
                        <base-input v-model="form.likely_cause" :label="language_terms['LIKELY_CAUSE']" :disabled="!is_editing"></base-input>
                    </b-col>
                    <b-col lg="6">
                          <base-input v-model="form.reported_by" :label="language_terms['REPORTED_BY']" :disabled="!is_editing"></base-input>
                    </b-col>
                </b-row>
            </card>
            <div class="floating-bar">
                <div class="floating-bar-container" align="center">
                    <b-button-group>
                        <b-button class="transparent-btn" @click="onClickEdit()"  v-if="(!is_editing && form.is_posted == 0 && (form.is_approved == null || form.is_approved == 0))">
                            <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                        </b-button>
                        <b-button class="transparent-btn" v-if="is_editing"  @click="onClickSave()">
                            <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="onClickCancel()">
                            <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CLOSE']}}
                        </b-button>
                    </b-button-group>
                </div>
            </div>
        </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import moment from "moment";
import {Table,TableColumn,Select, Option } from "element-ui";
import productLookup from "@/components/Autocomplete.vue";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import BaseButton from '../../components/BaseButton.vue';
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import BaseInput from '../../components/Inputs/BaseInput.vue';
import Vue from 'vue'

// import Calendar from '../Calendar/Calendar.vue';
export default {
components:{
  [Table.name]: Table,
  [TableColumn.name]: TableColumn,
  [Select.name]: Select,
  [Option.name]: Option,
  flatPicker,
  productLookup,
  Loading,
  BaseButton,
    BaseInput,
  //   Calendar,
},
computed:{
  ...mapState({
      customerProducts:state => state.sales.retrieve_invoice_products,
      language_terms: state => state.languages.language_terms,
      selected_lang: state => state.languages.selected_langauge,
  }),
},
data(){
  return{
      contacts:[],
      invoices:[],
      is_editing:0,
      title:"",
      loadingCounter:0,
      form:
      {
          customer:null,
          contact_code:'',
          contact_name:'',
          returnOthers:"",
          selected_invoice:{},
          selected_contact:{},
          id:null,
          contact_id: null,
          document_id: null,
          $doc_id:null,
          date:null,
          action_recommended: null,
          returned_by: null,
          incident_remarks: null,
          instructions: null,
          likely_cause: null,
          reported_by: null,
          items:[],
      },
      loading:false,
      is_edit:false,

      returnedBy:[
          {
              value: "2",
              label: "Purchaser",
          },
          {
              value: "3",
              label: "Deliveryman",
          },
          {
              value: "4",
              label: "Vendor",
          },
          {
              value: "1",
              label: "Others",
          },

      ],
      activeOptions: [
          {
              key: "Faulty Goods",
              label: "Faulty Goods",
          },
          {
              key: "Exchange/Rework",
              label: "Exchange/Rework",
          },
          {
              key: "Installation Charges",
              label: "Installation Charges",
          },
          {
              key: "Replacement",
              label: "Replacement",
          },
          {
              key: "Site Inspection/Repair",
              label: "Site Inspection/Repair",
          },
          {
              key: "Order Cancelled/Rejected",
              label: "Order Cancelled/Rejected",
          },
          {
              key: "Repair/Checking",
              label: "Repair/Checking",
          },
          {
              key: "Sample Return",
              label: "Sample Return",
          },
          {
              key: "Credit/Debit Note",
              label: "Credit/Debit Note",
          },
          {
              key: "Others",
              label: "Others",
          },
      ],
      mark:"",
      // report:{
      //     customers:[],
      //     invoices:[],
      // },
      item:{
          source_document_item_id:null,
          product_code: null,
          product_name: null,
          qty: null,
          uom: null,
          unit_price: null,
          qty_return: null,
          total_amount: null,
      }
  }
},
async mounted()
  {
      let id = this.$route.params.id
      if(id == '_new')
      {
          this.title = this.language_terms['NEW_PURCHASE_RETURNS']
          this.is_editing = true
          this.form.date = moment().format("YYYY-MM-DD");
      }
      else
      {
          this.is_editing = false
          await this.retrievePRT(id)
        this.title = this.language_terms['PURCHASE_RETURNS'] + ' ' + [id]
          this.is_editing = false
          await this.asyncFindVendor(this.form.contact_code);

          let selected_contact = {
              id: this.form.contact_id,
              code: this.form.contact_code,
              name: this.form.contact_name,
          };

          this.form.customer = selected_contact;
      }
  },
methods:{
  async retrievePRT(code)
  {
  this.loadingCounter++
      let payload = {code:code}
      await axios
        .post(apiRoutes["PURCHASERETURN_RETRIEVE"], payload, authHeader())
      .then((response) =>
      {
      if (response.data.code == 1) {
          this.form = response.data.data
      }
      else
      {
          alert('Failed');
      }

      })
      .catch((error) => {
      if (error.response) {
          Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
      }
      });
      this.loadingCounter--
  },
  async onClickEdit()
  {
      this.is_editing = true
  },
  async onClickSave()
  {
      this.loading = true
          let payload = this.form
          await axios
            .post(apiRoutes["PURCHASERETURN_SAVE"], payload, authHeader())
          .then((response) =>
          {
              if (response.data.code == 1) {
                  this.is_edit = 0;
                  this.$router.push("/purchase/purchase-return")
                  Vue.notify({group: 'notify', type: 'success', text: response.data.msg, max: 5, duration: 5000, speed: 300})
              }
              else
                  Vue.notify({group: "notify", type: "error", text: response.data.msg, max: 5, duration: 5000, speed: 300,});
          })
          .catch((error) => {
              if (error.response)
                  Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          });

      this.loading = false

  },
  clickOnBack()
  {
      this.$router.push("/purchase/purchase-return")
  },
  async onClickCancel()
  {
      if(this.$route.params.id == '_new')
      {
          this.$router.push("/purchase/purchase-return")
      }
      else
      {
          //location.reload();
          this.$router.push("/purchase/purchase-return")
      }
  },
  isEmptyObj(obj) {
      for(var prop in obj)
      {
          if(obj.hasOwnProperty(prop))
          {
              return false;
          }
      }
      return JSON.stringify(obj) === JSON.stringify({});
  },
  EmptyObj(obj) {
      for(var prop in obj)
      {
          if(obj.hasOwnProperty(prop))
          {
              return true;
          }
      }
      return JSON.stringify(obj) === JSON.stringify({});
  },
  async onSelectCustomer(obj)
  {
      if(obj){
          if(obj != this.form.selected_contact)
          {
              this.invoices = []
              this.form.selected_invoice = {}
              await this.$store.dispatch("sales/setInvoiceProducts", [])

          }
      }
  },
  customerNameWithCode ({ name, code })
  {
      if(name || code)
          return `${name} (${code})`
  },
  invoiceNameWithCode ({ code })
  {
      if(code)
          return `${code}`
  },
  async asyncFindVendor(query)
  {
      this.isLoading = true;
      let pv = { value: query };
      await axios
          .post(apiRoutes["VENDOR_LOOKUP"], pv, authHeader())
          .then((response) => {
          if (response.data.code == 1) {

              this.contacts = response.data.data;

          } else {
              this.contacts = [];
          }

          this.isLoading = false;
          })
          .catch((error) => {
          if (error.response)
          {
              Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300});}
              else
              {
                  console.log("Problem ", error);
              }
          });
  },
  async asyncFindInvoices()
  {
      // Invoice LookUp
      this.isLoading = true;
      let payload = {contact_id : this.form.selected_contact.id}
      //let pv = {"contact_id": {"operator":"=", "value": this.form.selected_contact.id}}
      await axios
          .post(apiRoutes["PURCHASERETURN_RETRIEVE_INVOICES"], payload, authHeader())
          .then((response) => {
          if (response.data.code == 1) {

              this.invoices = response.data.data;
          }
          else
          {
              this.invoices = [];
          }

          this.isLoading = false;
          })
          .catch((error) => {
          if (error.response)
          {
              Vue.notify({ group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300});}
              else
              {
                  console.log("Problem ", error);
              }
          });
  },
    onSelectInvoice(obj)
  {
      if(obj.code)
      {
        this.retrieveInvoiceItems(obj.code)
      }
  },
  async retrieveInvoiceItems(code)
  {

      // this.selectedInvoice = invoice
      let payload = {document_code : code}
        await axios.post(apiRoutes['PURCHASERETURN_RETRIEVE_INVOICE_ITEMS'], payload, authHeader()).then((response) =>
        {
            if (response.data.code == 1)
            {
                this.form.items = response.data.data
            }
          else
              Vue.notify({group: "notify", type: "error", text: response.data.msg, max: 5, duration: 5000, speed: 300,});
      })
      .catch((error)=> {
          if(error.response)
          {
              Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
          }
      });
  },

routeToMaster()
{
  this.$router.push("/purchase/purchase-return");
},
},
}
</script>
